/** Strip diacritics so Czech text can be searched accent-insensitively
 *  ("hrus" matches "Hruska"). */
export function fold(s: string): string {
  return s.normalize("NFD").replace(/[̀-ͯ]/gu, "").toLowerCase();
}

export function includesFolded(haystack: string, needle: string): boolean {
  return fold(haystack).includes(fold(needle.trim()));
}
